import { useContext } from "react";
import LanguageProviderContext from "../../pages/routing/providers/language/language.context";

const useLanguage = () => {
  const context = useContext(LanguageProviderContext);

  if (context === undefined)
    throw new Error("useLanguage must be used within a LanguageProvider");

  return context;
};

export default useLanguage;
